/* eslint-disable react/jsx-indent */
/* eslint-disable indent */
import { useEffect, useRef, useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon, CopyIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Card,
  CardBody,
  Code,
  Flex,
  Heading,
  IconButton,
  Input,
  Text,
  Tooltip,
  useToast,
  VStack,
} from '@chakra-ui/react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { getSelectRequestScreenSearchQuery } from '../../../../redux/manualVerification/sessionsDetails/selectors';
import { updateActiveStep as updateManualVerificationActiveStep } from '../../../../redux/manualVerification/stepperDetails';
import { updateSelectedInstances } from '../../../../redux/providerBuilder/selectedInstances';
import { getSelectedInstances } from '../../../../redux/providerBuilder/selectedInstances/selectors';
import {
  getSelectedNetworkIndex,
  getSelectedNetworkRequest,
} from '../../../../redux/providerBuilder/selectedNetworkRequest/selectors';
import { useDebounce } from '../../../../utils/logs/send-logs';
import {
  checkIfVariableNameExists,
  escapeRegExp,
  getMatchIndexes,
  getValueByPath,
  isValidVariableName,
} from '../../../../utils/provider-builder/instance-selection-utils';
import AddInstanceModal from '../../../provider-builder/components/request-selection/add-instance-modal.component';
import OptimizedJsonViewerWithWorker from '../../../provider-builder/components/request-selection/optimized-json-viewer-with-worker.component';
import ReportIssueModal from '../../../provider-builder/components/request-selection/report-issue-modal.component';
import { SelectedInstancesTable } from '../../../provider-builder/components/request-selection/selected-instances-table.component';

export const ManualVerificationSelectDataScreen = () => {
  const toast = useToast();
  const dispatch = useAppDispatch();

  const selectedNetworkRequest = useAppSelector(getSelectedNetworkRequest);
  const selectedNetworkIndex = useAppSelector(getSelectedNetworkIndex);
  const selectedInstances = useAppSelector(getSelectedInstances);
  const selectedInstancesRef = useRef(selectedInstances);
  // const selectedSessionData = useAppSelector(getSelectedManualVerificationSessionData)
  const searchText = useAppSelector(getSelectRequestScreenSearchQuery);
  // const clickedParameterName = useAppSelector(getSelectRequestScreenClickedParameterName)

  const [sections, setSections] = useState<any>([]);
  const [queryInstanceCount, setQueryInstanceCount] = useState<number>(0);
  const [buttonLoading, setButtonLoading] = useState(false);
  // const [variableNameOfIntanceInput, setVariableNameOfIntanceInput] =
  //     useState(clickedParameterName)
  const [selectedQueryInstance, setSelectedQueryInstance] = useState<number>(0);
  const [searchInstanceInput, setSearchInstanceInput] = useState(searchText);
  const debouncedSearchInstanceInput = useDebounce(searchInstanceInput, 1000);

  const [timerId, setTimerId] = useState<NodeJS.Timeout | null>(null);
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  // const [selectedJsonInstanceData, setSelectedJsonInstanceData] = useState<any>(
  //     {}
  // )
  // const [requiredVariableNames, setRequiredVariableNames] = useState<any[]>([])

  useEffect(() => {
    if (timerId) {
      clearTimeout(timerId);
    }

    const newTimerId = setTimeout(() => {
      handleSelectNetworkRequest();
    }, 500);
    setTimerId(newTimerId);
    return () => {
      clearTimeout(newTimerId);
    };
  }, [debouncedSearchInstanceInput]);

  useEffect(() => {
    selectedInstancesRef.current = selectedInstances;
  }, [selectedInstances]);

  // useEffect(() => {
  //     if (selectedNetworkRequest.contentType.includes('json')) {
  //         const data = JSON.parse(selectedNetworkRequest?.response?.body)
  //         const expandedPaths = getAllPaths('', data, '')
  //         expandedPaths[''] = true
  //         dispatch(updateExpandedPaths(expandedPaths))
  //     }
  // }, [sections])

  // useEffect(() => {
  //     if (selectedSessionData?.id && selectedSessionData?.parameters?.length) {
  //         const tempUsernames = selectedSessionData?.parameters?.map((param: any) => param?.key)
  //         setRequiredVariableNames(tempUsernames)
  //     }
  // }, [selectedSessionData])

  // set selected text to the selectedText state
  const handleInstanceSelect = () => {
    const selection = window.getSelection()?.toString();
    if (selection?.length) {
      setSearchInstanceInput(selection);
    }
  };

  function handleSelectNetworkRequest(): void {
    const responseBody = selectedNetworkRequest[selectedNetworkIndex]?.response?.body;
    const chunks: {
      t: any;
      marked: boolean;
      i?: number;
      start?: number;
      last?: number;
      regx?: any;
      jsonPath?: string;
    }[] = [];
    let last = 0;
    let count = 0;

    if (debouncedSearchInstanceInput.length) {
      if (selectedNetworkRequest[selectedNetworkIndex]?.contentType?.includes('json')) {
        handleNext(true);
        return;
      }

      const searchQueryInputsize = debouncedSearchInstanceInput.length;
      const matchIndexs = getMatchIndexes(responseBody, debouncedSearchInstanceInput);
      if (
        matchIndexs.length === 0 &&
        selectedNetworkRequest[selectedNetworkIndex]?.contentType?.includes('html')
      ) {
        toast({
          title: 'No Match Found. Please try again',
          status: 'error',
          duration: 2000,
          isClosable: true,
          position: 'top-right',
        });
        return;
      }

      if (selectedNetworkRequest[selectedNetworkIndex]?.contentType?.includes('html')) {
        matchIndexs.forEach((index) => {
          const start = index;
          count += 1;
          chunks.push({
            t: responseBody.substring(last, start),
            marked: false,
          });
          last = start + searchQueryInputsize;
          chunks.push({
            i: count,
            t: responseBody.substring(start, last),
            marked: true,
            start,
            last,
          });
        });
      }
    }

    setSelectedQueryInstance(count ? 1 : 0);

    chunks.push({ t: responseBody.substring(last), marked: false });
    setSections(chunks);
    setQueryInstanceCount(count);

    setTimeout(() => {
      document?.getElementById('queryMatch1')?.scrollIntoView();
      document?.getElementById('requestDataTitle')?.scrollIntoView();
    }, 100);
  }

  function addSelectedJsonInstanceToList(name: string, jsonData: any) {
    let variableName = name;

    if (!variableName.trim() || !isValidVariableName(variableName)) {
      return toast({
        title: 'Error',
        description: 'Invalid key name',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      });
    }

    if (checkIfVariableNameExists(selectedInstancesRef.current, variableName)) {
      const randomNumber = Math.floor(10000 + Math.random() * 90000);
      variableName = `${variableName}_${randomNumber}`;
    }

    const xPath = '';

    const selectedInstData = { ...jsonData };

    if (selectedInstData?.regx) {
      const regexMat = /({{.*?}})/g;
      const matches = selectedInstData.regx.match(regexMat) || [];
      if (matches.length > 0) {
        selectedInstData.regx = selectedInstData?.regx.replace(
          matches[0],
          '{{' + variableName + '}}'
        );
      }
    }

    const regex = selectedInstData?.regx;

    const newSelectedInstanceList = {
      data: selectedInstData?.data,
      variableName: variableName,
      responseSelection: {
        xPath: xPath,
        jsonPath: selectedInstData?.jsonPath ?? '',
        responseMatch: regex,
        invariant: selectedInstData?.invariantChecked,
        isPrivateInformation: selectedInstData?.isPrivateInformation,
        matchType: 'greedy',
      },
    };

    dispatch(updateSelectedInstances(newSelectedInstanceList));
  }

  function handleItemClick(
    path: string,
    key: string = 'aa',
    isUniqueToUser: boolean,
    isPrivateInformation: boolean
  ) {
    const jsonPath = `$${path}`;

    const pathAlreadyExists = selectedInstancesRef.current.some(
      (instance) =>
        instance.responseSelection.jsonPath === jsonPath &&
        instance.responseSelection.requestIndex === selectedNetworkIndex
    );

    if (pathAlreadyExists) {
      return toast({
        title: 'Error',
        description: 'This Variable is already added..',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      });
    }

    let selectedValue = getValueByPath(
      JSON.parse(selectedNetworkRequest[selectedNetworkIndex]?.response?.body),
      path
    );

    let regx;

    if (typeof selectedValue === 'object') {
      selectedValue = JSON.stringify(selectedValue);
      regx = `"${path.split('.').pop()}":${escapeRegExp(
        selectedValue.replace(selectedValue, 'CLAIM_DATA')
      ).replace('CLAIM_DATA', '{{CLAIM_DATA}}')}`;
    } else if (typeof selectedValue === 'number' || typeof selectedValue === 'boolean') {
      const selectedValueString = `${selectedValue}`;
      regx = `"${path.split('.').pop()}":${escapeRegExp(
        selectedValueString?.replace(selectedValueString, 'CLAIM_DATA')
      ).replace('CLAIM_DATA', '{{CLAIM_DATA}}')}`;
    } else {
      regx = `"${path.split('.').pop()}":"${escapeRegExp(
        selectedValue.replace(selectedValue, 'CLAIM_DATA')
      ).replace('CLAIM_DATA', '{{CLAIM_DATA}}')}"`;
    }

    addSelectedJsonInstanceToList(key, {
      data: selectedValue,
      jsonPath,
      regx,
      invariantChecked: isUniqueToUser,
      isPrivateInformation,
    });
  }

  function handleNext(highlightFirst: boolean = false) {
    const allHighlights = document.querySelectorAll<HTMLElement>(
      '.highlight-searched-json-value'
    );
    if (allHighlights.length > 0) {
      if (currentIndex >= 0 && currentIndex < allHighlights.length) {
        allHighlights[currentIndex].style.border = '';
        allHighlights[currentIndex].style.borderRadius = '';
        allHighlights[currentIndex].style.padding = '0px';
      }

      let nextIndex;
      if (highlightFirst) {
        nextIndex = 0;
      } else {
        nextIndex = (currentIndex + 1) % allHighlights.length;
      }

      setCurrentIndex(nextIndex);
      allHighlights[nextIndex].style.border = '2px solid blue';
      allHighlights[nextIndex].style.borderRadius = '99999px';
      allHighlights[nextIndex].style.padding = '0 5px';
      allHighlights[nextIndex].scrollIntoView({ behavior: 'smooth' });
    }
  }

  function handlePrevious() {
    const allHighlights = document.querySelectorAll<HTMLElement>(
      '.highlight-searched-json-value'
    );
    if (allHighlights.length > 0) {
      if (currentIndex >= 0 && currentIndex < allHighlights.length) {
        allHighlights[currentIndex].style.border = '';
        allHighlights[currentIndex].style.borderRadius = '';
        allHighlights[currentIndex].style.padding = '0px';
      }

      const prevIndex = currentIndex === 0 ? allHighlights.length - 1 : currentIndex - 1;
      setCurrentIndex(prevIndex);

      allHighlights[prevIndex].style.border = '2px solid blue';
      allHighlights[prevIndex].style.borderRadius = '99999px';
      allHighlights[prevIndex].style.padding = '0 5px';

      allHighlights[prevIndex].scrollIntoView({ behavior: 'smooth' });
    }
  }

  function handleGoBack() {
    dispatch(updateManualVerificationActiveStep(3));
  }

  // function handleExistingParameterDelete(key: string) {
  //     const index = selectedInstances.findIndex((instance) => instance.variableName === key)
  //     dispatch(deleteSelectedInstance(index))
  // }

  function copyResponseBody() {
    navigator.clipboard
      .writeText(selectedNetworkRequest[selectedNetworkIndex]?.response?.body ?? '')
      .then(() => {
        toast({
          title: 'Response body copied',
          status: 'success',
          duration: 1000,
          isClosable: true,
          position: 'top-right',
        });
      })
      .catch((err) => {
        console.error('Failed to copy text to clipboard', err);
      });
  }

  return (
    <>
      <Card variant="outline" h="100%">
        <CardBody overflowX="hidden">
          <VStack>
            <Box w="full">
              <Flex gap="50px" justifyContent="space-between">
                <Box w="50%" maxW="600px">
                  <Flex direction="column" gap={2}>
                    <Flex
                      direction="column"
                      gap={2}
                      py={1}
                      px={1}
                      borderBottom="1px solid #EFF1F5"
                    >
                      <Heading className="regular-font">Select Data</Heading>
                      <Text className="small-font" lineHeight="24px" color="#98A2B3">
                        Click on the key to add it as required data in the proof
                      </Text>
                    </Flex>
                    <Flex direction="column" gap={2} py={5} px={1}>
                      <Flex alignItems="center" gap={2}>
                        <Input
                          placeholder="Search the data you want to verify"
                          _placeholder={{ color: '#667085', fontSize: '14px' }}
                          fontSize="clamp(11px, calc(0.7 * 1.6), 20px)"
                          value={searchInstanceInput}
                          onChange={(e) => setSearchInstanceInput(e.target.value)}
                        />
                        {selectedNetworkRequest[
                          selectedNetworkIndex
                        ]?.contentType?.includes('json') ? (
                          <>
                            <IconButton
                              aria-label="up"
                              onClick={handlePrevious}
                              icon={<ChevronUpIcon fontSize="2rem" />}
                            />
                            <IconButton
                              aria-label="down"
                              onClick={() => handleNext()}
                              icon={<ChevronDownIcon fontSize="2rem" />}
                            />
                          </>
                        ) : (
                          <>
                            <IconButton
                              aria-label="up"
                              onClick={() => {
                                setSelectedQueryInstance(selectedQueryInstance - 1);
                                document
                                  .getElementById(
                                    `queryMatch${selectedQueryInstance - 1}`
                                  )
                                  ?.scrollIntoView();
                              }}
                              isDisabled={
                                queryInstanceCount === 0 || selectedQueryInstance === 1
                              }
                              icon={<ChevronUpIcon fontSize="1.5rem" />}
                            />
                            <IconButton
                              aria-label="down"
                              isDisabled={selectedQueryInstance === queryInstanceCount}
                              onClick={() => {
                                setSelectedQueryInstance(selectedQueryInstance + 1);
                                document
                                  .getElementById(
                                    `queryMatch${selectedQueryInstance + 1}`
                                  )
                                  ?.scrollIntoView();
                              }}
                              icon={<ChevronDownIcon fontSize="1.5rem" />}
                            />
                            <AddInstanceModal
                              searchInstanceInput={debouncedSearchInstanceInput}
                              selectedQueryInstance={selectedQueryInstance}
                              sections={sections}
                            />
                          </>
                        )}
                      </Flex>
                      <ReportIssueModal
                        searchInstanceInput={debouncedSearchInstanceInput}
                      />
                    </Flex>
                  </Flex>
                </Box>
                <SelectedInstancesTable />
              </Flex>
            </Box>
            <Box w="full">
              <Flex direction="column" w="full">
                <Box>
                  <Flex direction="column" gap={2} py={5} px={1}>
                    <Heading className="medium-font">Body</Heading>
                    <Box
                      backgroundColor="gray.50"
                      borderRadius="5px"
                      p={2}
                      pt={4}
                      minHeight="30vh"
                      maxHeight="50vh"
                      overflow="auto"
                      position="relative"
                      w="full"
                    >
                      <IconButton
                        aria-label="copy"
                        onClick={copyResponseBody}
                        icon={<CopyIcon color="black" />}
                        size="small"
                        position="absolute"
                        right={3}
                        top={2}
                        zIndex={10}
                        cursor="pointer"
                      />

                      {sections ? (
                        <>
                          {selectedNetworkRequest[
                            selectedNetworkIndex
                          ]?.contentType?.includes('json') ? (
                            <>
                              <OptimizedJsonViewerWithWorker
                                jsonString={
                                  selectedNetworkRequest[selectedNetworkIndex]?.response
                                    ?.body
                                }
                                onItemClick={handleItemClick}
                                searchTerm={debouncedSearchInstanceInput}
                                isDisabled={
                                  selectedNetworkRequest[selectedNetworkIndex]?.response
                                    ?.body?.length > 50000
                                }
                              />
                            </>
                          ) : (
                            <>
                              <Text
                                onMouseUp={handleInstanceSelect}
                                style={{
                                  fontVariantNumeric: 'tabular-nums',
                                }}
                                color="#000"
                                fontWeight="400"
                                className="font-roboto-mono-regular medium-font"
                              >
                                {sections.map((section: any, i: any) =>
                                  section.marked ? (
                                    <span
                                      key={i}
                                      id={`queryMatch${section.i}`}
                                      style={{
                                        backgroundColor: 'yellow',
                                        cursor: 'pointer',
                                        borderColor:
                                          section.i === selectedQueryInstance
                                            ? 'red'
                                            : undefined,
                                        borderWidth: '2px',
                                        fontWeight:
                                          section.i === selectedQueryInstance
                                            ? 'bold'
                                            : undefined,
                                        padding:
                                          section.i === selectedQueryInstance
                                            ? '0.2rem'
                                            : '0.1rem',
                                        borderRadius: '30%',
                                      }}
                                      onClick={() => setSelectedQueryInstance(section.i)}
                                    >
                                      {section.t}
                                    </span>
                                  ) : (
                                    section.t
                                  )
                                )}
                              </Text>
                            </>
                          )}
                        </>
                      ) : (
                        <Code
                          style={{
                            maxHeight: '600px',
                            overflow: 'auto',
                          }}
                          className="font-roboto-mono-regular"
                        >
                          {selectedNetworkRequest[selectedNetworkIndex]?.response?.body}
                        </Code>
                      )}
                    </Box>
                  </Flex>
                </Box>
              </Flex>
            </Box>
          </VStack>
        </CardBody>
        <Box w="full" backgroundColor="gray.50" px={30} py={4}>
          <Flex w="full" justifyContent="space-between">
            <Button
              onClick={handleGoBack}
              backgroundColor="transparent"
              border="1px solid gray"
              borderRadius={10}
              fontWeight="normal"
              _hover={{
                fontWeight: 'bold',
                transform: 'scale(1.05)',
              }}
            >
              Back
            </Button>
            <Tooltip
              label={
                selectedInstances.length
                  ? ''
                  : 'Please add at least one data instance to proceed'
              }
            >
              <Button
                backgroundColor="black"
                color="white"
                border="1px solid black"
                borderRadius={10}
                fontWeight="normal"
                _hover={{
                  transform: 'scale(1.05)',
                }}
                isLoading={buttonLoading}
                isDisabled={!selectedInstances.length}
                onClick={() => {
                  setButtonLoading(true);
                  dispatch(updateManualVerificationActiveStep(5));
                }}
              >
                Next
              </Button>
            </Tooltip>
          </Flex>
        </Box>
      </Card>
    </>
  );
};
